import { trackEvent } from '@domain/analytics/trackEvent';
import { EventMykissSearchResultSelected } from '@generated/events';
import { ISearchGroup, ISearchOption } from '@app-types/search';

export const trackOptionSelected = (
  option: ISearchOption,
  source: EventMykissSearchResultSelected['properties']['source'],
  currentPage: string,
  group: ISearchGroup,
  searchTerm: string,
): void => {
  trackEvent({
    name: 'mykiss_search_result_selected',
    properties: {
      source,
      page: currentPage,
      item_name: option.title,
      item_id: option.id,
      item_type: group.type,
      search_term: searchTerm,
    },
  });
};
